export default __webpack_public_path__ + "9999920b9e6c6830ebc4ce18b16a5519.webp";